module.exports = __webpack_public_path__ + "static/media/HR_iPad_Horizontal.ba93b722.png";